import React from 'react';
type Tome = {
  number: string;
  title: string;
  range: string;
  promise: string;
  badge: string;
  badgeText: string;
  flag?: string;
  contents: string[];
};
const tomes: Tome[] = [{
  number: '01',
  title: 'The Flight Path System',
  range: 'Foundations & safe teaching · any apparatus',
  promise: 'Ready-to-run foundation classes plus the safe-teaching system behind every aerial class.',
  badge: 'bg-coral',
  badgeText: 'text-white',
  flag: 'Start here',
  contents: ['The 4-Block Session Formula: 45 / 60 / 75 minutes', 'The Pre-Flight Check: 7 things to clear before anyone leaves the floor', 'Grip, core, invert-prep, flexibility & conditioning classes', 'Spotting, cueing and 40 cues that fix common positions']
}, {
  number: '02',
  title: 'Silks Class-Ready',
  range: 'Beginner term · 12 classes',
  promise: 'From first grip to a first sequence, top to bottom, on the Silks Flight Path.',
  badge: 'bg-teal',
  badgeText: 'text-white',
  contents: ['First climb, footlocks and safe descents', 'Seat, hip key and first wraps — checked before weighted', 'Cross-back straddle and controlled inversions', 'Progress Anchor: know a student owns a skill before the next']
}, {
  number: '03',
  title: 'Hoop (Lyra) Class-Ready',
  range: 'Beginner to intermediate · 12 classes',
  promise: 'From first mount to first combo, on the Hoop Flight Path.',
  badge: 'bg-amber',
  badgeText: 'text-ink',
  contents: ['The Mount Map: safe ways into the hoop by level', 'Man in the moon, delilah, gazelle, amazon & mermaid', 'Pullover to top bar and controlled beginner spins', 'A rotation plan for one hoop, many students']
}, {
  number: '04',
  title: 'Trapeze Class-Ready',
  range: 'Static trapeze term · 12 classes',
  promise: 'From mount and sit to a first trapeze sequence, on the Trapeze Flight Path.',
  badge: 'bg-indigo',
  badgeText: 'text-white',
  contents: ['The Bar & Rope Map: holds, grips and where to support', 'Mermaid, gazelle, birds nest and knee hangs', 'Catchers hang & standing on the bar, spotted', 'Beats and simple static swing basics']
}, {
  number: '05',
  title: 'Intermediate & Combinations',
  range: 'All three apparatus · 15 classes',
  promise: 'Take students past beginner without leaving anyone behind.',
  badge: 'bg-coral',
  badgeText: 'text-white',
  contents: ['The Combo Bridge: single skills into combinations', 'The Transition Map: the moves that connect everything', 'Four intermediate classes per apparatus', 'A mixed-level combo class for three levels at once']
}, {
  number: '06',
  title: 'Choreography, Routines & Showcase',
  range: 'Routines + a student showcase',
  promise: 'Turn skills into routines your students are proud to show.',
  badge: 'bg-teal',
  badgeText: 'text-white',
  contents: ['The Routine Arc: a beginning, a climb and a finish', 'The Beat Map: musicality by BPM, no copyrighted tracks', 'Ready beginner routines for silks, hoop & trapeze', 'Run a student showcase from start to finish']
}];
const everyVolume = ['Self-contained Class Plans: open one page, run the session', 'Worksheets you print and reuse (25 in the pack)', 'Session Formula for 45, 60 and 75-minute slots', 'Instructor Notes, Quick Wins, 12 troubleshooting fixes and a field card'];
export function Tomes() {
  return <section aria-labelledby="tomes-heading" className="w-full bg-white text-ink" data-id="element-388" data-mp="mwxi367zj3e9">
      <div className="max-w-6xl mx-auto px-5 py-16 sm:py-20" data-id="element-389" data-mp="rndviqbt2p0m">
        <div className="text-center" data-id="element-390" data-mp="royowcmdw1ww">
          <p className="text-[11px] font-semibold uppercase tracking-[1.6px] text-teal-deep" data-id="element-391" data-mp="3ravmdliukh2r">Your whole year</p>
          <h2 id="tomes-heading" className="mt-3 font-display text-3xl font-extrabold text-ink sm:text-5xl" data-id="element-392" data-mp="3vc8rfte48g8m">
            Inside the pack — six volumes
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-base text-slate" data-id="element-393" data-mp="3c5rkylzwrbc4">
            60+ class plans in the order you teach them, each volume building on
            the last. Teach one apparatus? Open its volume and start this week.
            Teach all three? The pack covers a full year of weekly classes.
          </p>
        </div>

        <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-394" data-mp="3uxu4c53xp5q2">
          {tomes.map(tome => <article key={tome.number} className={`flex flex-col rounded-2xl border bg-white p-6 shadow-soft ${tome.flag ? 'border-coral ring-1 ring-coral' : 'border-cloud-dark'}`} data-id="element-395" data-mp="3q0214exu9x6k">
              <div className="flex items-center gap-2.5" data-id="element-396" data-mp="3pzjw9hz1dsq">
                <span className={`flex h-9 w-9 items-center justify-center rounded-full font-display text-base font-bold ${tome.badge} ${tome.badgeText}`} data-id="element-397" data-mp="2ajjtd32fvzh3">
                  {tome.number}
                </span>
                <span className="text-[11px] font-semibold uppercase tracking-widest text-slate" data-id="element-398" data-mp="l1wm6mec6wb8">Volume {tome.number}</span>
                {tome.flag && <span className="ml-auto rounded-full bg-coral px-2.5 py-1 text-[10px] font-bold uppercase tracking-wider text-white" data-id="element-399" data-mp="bbv0205jnnyy">
                    {tome.flag}
                  </span>}
              </div>
              <h3 className="mt-3 font-display text-xl font-bold leading-tight tracking-tight text-ink" data-id="element-400" data-mp="2a3ssqvcv92z">{tome.title}</h3>
              <p className="mt-1 text-[11px] font-semibold uppercase tracking-widest text-coral-deep" data-id="element-401" data-mp="6dte97gqhajs">{tome.range}</p>
              <p className="mt-2 text-sm text-slate" data-id="element-402" data-mp="3okg4ox77qnsu">{tome.promise}</p>
              <ul className="mt-4 grid gap-2 border-t border-cloud-dark pt-4" data-id="element-403" data-mp="3thq1wz0ug3r8">
                {tome.contents.map(item => <li key={item} className="flex gap-2 text-[13px] text-ink" data-id="element-404" data-mp="1moxeaok681fy">
                    <span className={`mt-[7px] h-1.5 w-1.5 flex-none rounded-full ${tome.badge}`} data-id="element-405" data-mp="1rp1vyhwtf27r" />
                    {item}
                  </li>)}
              </ul>
            </article>)}
        </div>

        <div className="mt-6 rounded-2xl bg-ink px-5 py-5 text-white sm:px-7" data-id="element-406" data-mp="1gai4rfi6732l">
          <p className="text-[11px] font-semibold uppercase tracking-widest text-amber" data-id="element-407" data-mp="1gcks1rrxui3m">In every volume</p>
          <ul className="mt-3 grid gap-2 sm:grid-cols-2 lg:grid-cols-4" data-id="element-408" data-mp="1bdroos6d87h6">
            {everyVolume.map(item => <li key={item} className="flex gap-2 text-[13px] text-white/85" data-id="element-409" data-mp="240ceho770bim">
                <span className="mt-[7px] h-1.5 w-1.5 flex-none rounded-full bg-coral" data-id="element-410" data-mp="242f3c4wlzylr" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}